import React, { useEffect, useMemo, useState } from 'react';
import './CardVIew.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { useAuth } from '../../AuthContext';
import { API_URL } from '../../Config';
import { Link } from 'react-router-dom';

const CardView = () => {
  const [isFormOpenForAddTask, setIsFormOpenForAddTask] = useState(false);
  const [isFormOpenForCard, setIsFormOpenForCard] = useState(false);
  const { user } = useAuth();
  const username = user.user;
  const [tasks, setTasks] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [searchInput, setSearchInput] = useState('');
  const [selectedSort, setSelectedSort] = useState('');
  const [assigneeDetails, setAssigneeDetails] = useState(null);

  useEffect(() => {
    let endpoint = API_URL + `/tasks/?assignee=${username.username}`;

    if (username.role === 'Admin' || username.role === 'HR') {
      endpoint = API_URL + '/tasks/all';
    }

    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => setTasks(data))
      .catch((error) => console.error(error));
  }, [username.username, username.role]);

  const fetchTasks = (filterValue = '', sortValue = '') => {
    let endpoint;

    if (!filterValue && !sortValue) {
      endpoint =
        username.role === 'Admin' || username.role === 'HR'
          ? API_URL + '/tasks/all'
          : API_URL + `/tasks/?assignee=${username.username}`;
    } else if (username.role === 'Admin' || username.role === 'HR') {
      endpoint = `${API_URL}/tasks/?assignee=&filter=${filterValue}&sort=${sortValue}`;
    } else {
      endpoint = `${API_URL}/tasks/?assignee=${username.username}&filter=${filterValue}&sort=${sortValue}`;
    }

    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => setTasks(data))
      .catch((error) => console.error(error));
  };

  const openForm1 = () => setIsFormOpenForAddTask(true);
  const closeForm1 = () => setIsFormOpenForAddTask(false);

  const openForm2 = async (task) => {
    setSelectedTask(task);
    setIsFormOpenForCard(true);
    setAssigneeDetails(null);

    try {
      const response = await fetch(`${API_URL}/users/${task.assignee}`);
      if (!response.ok) throw new Error('Failed to fetch user details');
      const data = await response.json();
      setAssigneeDetails(data);
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };

  const closeForm2 = () => {
    setIsFormOpenForCard(false);
    setSelectedTask(null);
    setAssigneeDetails(null);
  };

  const clearFilters = () => {
    setSearchInput('');
    setSelectedSort('');
    fetchTasks('', '');
  };

  const visibleTasks = useMemo(() => tasks, [tasks]);

  const getPriorityClass = (value) => {
    const key = (value || '').toLowerCase();
    if (key === 'high') return 'priority_high';
    if (key === 'medium') return 'priority_medium';
    return 'priority_low';
  };

  const getStatusClass = (value) => {
    const key = (value || '').toLowerCase().replace(/\s+/g, '-');
    if (key === 'pending') return 'status_pending';
    if (key === 'completed' || key === 'complete') return 'status_completed';
    return 'status_process';
  };

  const getRoleClass = (value) => {
    const key = (value || '').toLowerCase().replace(/\s+/g, '-');
    if (key.includes('admin')) return 'role_admin';
    if (key.includes('manager')) return 'role_manager';
    return 'role_employee';
  };

  const completedCount = tasks.filter(
    (task) => (task.status || '').toLowerCase() === 'completed'
  ).length;

  const pendingCount = tasks.filter(
    (task) => (task.status || '').toLowerCase() === 'pending'
  ).length;

  return (
    <div className="cardview_app">
      <SideMenuBar />

      <main className="content">
        <NewHeader />

        <div className="cardview_container">
          <section className="tasks_page_heading">
            <div>
              <span className="page_kicker">WORK MANAGEMENT</span>
              <h1>Tasks</h1>
              <p>See your workload at a glance and open any task for complete details.</p>
            </div>

            <div className="view_switcher">
              <Link to="/ListView" className="view_tab">
                <span>☷</span>
                List
              </Link>
              <Link to="/CardVIew" className="view_tab active">
                <span>▦</span>
                Card
              </Link>
            </div>
          </section>

          <section className="task_toolbar">
            <div className="task_search_box">
              <img src="../assets/search.png" alt="" />
              <input
                aria-label="Search tasks"
                placeholder="Search tasks or assignees..."
                value={searchInput}
                onChange={(e) => {
                  const text = e.target.value;
                  setSearchInput(text);
                  fetchTasks(text, selectedSort);
                }}
              />
              {searchInput && (
                <button
                  type="button"
                  className="clear_search_button"
                  onClick={() => {
                    setSearchInput('');
                    fetchTasks('', selectedSort);
                  }}
                  aria-label="Clear search"
                >
                  ×
                </button>
              )}
              <kbd>⌘ K</kbd>
            </div>

            <select
              className="sort_by"
              value={selectedSort}
              aria-label="Sort tasks"
              onChange={(e) => {
                const value = e.target.value;
                setSelectedSort(value);
                fetchTasks(searchInput, value);
              }}
            >
              <option value="" disabled>Sort by</option>
              <option value="Pending">Pending</option>
              <option value="In-Process">In-Process</option>
              <option value="Complete">Complete</option>
            </select>

            <button type="button" className="clear_filter_btn" onClick={clearFilters}>
              Reset
            </button>

            <button type="button" className="add_task_btn" onClick={openForm1}>
              <span>+</span>
              Add task
            </button>
          </section>

          <section className="task_overview_strip">
            <div>
              <strong>{tasks.length}</strong>
              <span>Total tasks</span>
            </div>
            <div>
              <strong>{completedCount}</strong>
              <span>Completed</span>
            </div>
            <div>
              <strong>{pendingCount}</strong>
              <span>Pending</span>
            </div>
            <div className="overview_hint">
              <span className="overview_dot" />
              {visibleTasks.length ? 'Live workspace data' : 'No tasks available'}
            </div>
          </section>

          {isFormOpenForAddTask && (
            <>
              <div className="overlay_CardView" onClick={closeForm1} />

              <section
                className="popup-form_CardView"
                role="dialog"
                aria-modal="true"
                aria-labelledby="add-task-title-card"
              >
                <div className="modal_header_CardView">
                  <div>
                    <span className="page_kicker">WORK MANAGEMENT</span>
                    <h2 id="add-task-title-card">Create new task</h2>
                    <p>Capture the essential task information and workflow state.</p>
                  </div>
                  <button
                    type="button"
                    className="close_CardView"
                    onClick={closeForm1}
                    aria-label="Close add task"
                  >
                    ×
                  </button>
                </div>

                <form className="task_form_CardView">
                  <div className="form_grid_CardView">
                    <label className="form_field_CardView full_width_CardView">
                      <span>Assignee</span>
                      <input
                        className="enter_assignee_name_input_CardView"
                        placeholder="Enter name of the assignee"
                      />
                    </label>

                    <label className="form_field_CardView full_width_CardView">
                      <span>Task details</span>
                      <textarea
                        className="task_details_input_CardView"
                        placeholder="Enter task details..."
                      />
                    </label>

                    <label className="form_field_CardView">
                      <span>Priority</span>
                      <select className="popup_form_select">
                        <option value="" disabled selected>Select priority</option>
                        <option>High</option>
                        <option>Medium</option>
                        <option>Low</option>
                      </select>
                    </label>

                    <label className="form_field_CardView">
                      <span>Role</span>
                      <select className="popup_form_select">
                        <option value="" disabled selected>Select role</option>
                        <option>Super Admin</option>
                        <option>Hr Admin</option>
                        <option>Employee</option>
                      </select>
                    </label>

                    <label className="form_field_CardView">
                      <span>Status</span>
                      <select className="popup_form_select">
                        <option value="" disabled selected>Select status</option>
                        <option>Pending</option>
                        <option>In-Process</option>
                        <option>Complete</option>
                      </select>
                    </label>

                    <label className="form_field_CardView">
                      <span>Created date</span>
                      <input type="date" className="popup_form_created_date_CardView" />
                    </label>

                    <label className="form_field_CardView">
                      <span>Deadline</span>
                      <input type="date" className="popup_form_deadline_CardView" />
                    </label>

                    <label className="form_field_CardView">
                      <span>Given by</span>
                      <input
                        className="popup_form_given_by_CardView"
                        placeholder="Enter"
                      />
                    </label>
                  </div>

                  <div className="form_actions_CardView">
                    <button
                      type="button"
                      className="popup_form_cancel_CardView"
                      onClick={closeForm1}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="popup_form_addTask_CardView">
                      Create task
                    </button>
                  </div>
                </form>
              </section>
            </>
          )}

          <section className="tasks_section_CardView">
            <div className="section_header_CardView">
              <div>
                <span className="page_kicker">TASK BOARD</span>
                <h2>All tasks</h2>
              </div>
              <span className="table_count">{visibleTasks.length} records</span>
            </div>

            {visibleTasks.length > 0 ? (
              <div className="row_CardView">
                {visibleTasks.map((task, index) => (
                  <article
                    key={task.uuId || index}
                    className="task_card_CardView"
                    onClick={() => openForm2(task)}
                    tabIndex={0}
                    role="button"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') openForm2(task);
                    }}
                  >
                    <div className="task_card_top">
                      <span className="task_index">TASK {String(index + 1).padStart(2, '0')}</span>
                      <span className="task_arrow">↗</span>
                    </div>

                    <div className="task_assignee_CardView">
                      <span className="assignee_avatar">
                        {(task.assignee || '?').charAt(0).toUpperCase()}
                      </span>
                      <div>
                        <strong>{task.assignee || 'Unassigned'}</strong>
                        <small>{task.category || 'General task'}</small>
                      </div>
                    </div>

                    <div className="task_card_divider" />

                    <div className="task_card_info_grid">
                      <div>
                        <span>Priority</span>
                        <b className={`task_chip ${getPriorityClass(task.priority)}`}>
                          {task.priority || '—'}
                        </b>
                      </div>

                      <div>
                        <span>Role</span>
                        <b className={`task_chip ${getRoleClass(task.role)}`}>
                          {task.role || '—'}
                        </b>
                      </div>

                      <div>
                        <span>Deadline</span>
                        <strong>{task.deadline || '—'}</strong>
                      </div>

                      <div>
                        <span>Status</span>
                        <b className={`task_chip ${getStatusClass(task.status)}`}>
                          {task.status || '—'}
                        </b>
                      </div>
                    </div>

                    <div className="task_card_footer">
                      <span>Updated recently</span>
                      <span className="card_open_hint">View details →</span>
                    </div>
                  </article>
                ))}
              </div>
            ) : (
              <div className="empty_tasks_CardView">
                <div className="empty_tasks_icon_CardView">✓</div>
                <h3>No tasks found</h3>
                <p>Try changing your search or filters, or create a new task.</p>
                <button type="button" onClick={openForm1}>Create a task</button>
              </div>
            )}
          </section>

          {isFormOpenForCard && selectedTask && (
            <>
              <div className="overlay2_CardView" onClick={closeForm2} />

              <aside
                className="popup-form2_CardView"
                role="dialog"
                aria-modal="true"
                aria-labelledby="task-detail-title"
              >
                <div className="detail_header_CardView">
                  <div className="detail_identity_CardView">
                    <span className="detail_avatar_CardView">
                      {(selectedTask.assignee || '?').charAt(0).toUpperCase()}
                    </span>
                    <div>
                      <span className="page_kicker">TASK DETAILS</span>
                      <h2 id="task-detail-title">{selectedTask.assignee || 'Unassigned'}</h2>
                      <p>{selectedTask.category || 'General task'}</p>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="close2_CardView"
                    onClick={closeForm2}
                    aria-label="Close task details"
                  >
                    ×
                  </button>
                </div>

                <div className="detail_body_CardView">
                  <section className="detail_section_CardView">
                    <div className="detail_section_title">
                      <span>01</span>
                      <div>
                        <h3>Task information</h3>
                        <p>Current assignment and workflow details.</p>
                      </div>
                    </div>

                    <div className="detail_list_CardView">
                      <div><span>Task</span><strong>{selectedTask.category || 'Not available'}</strong></div>
                      <div><span>Priority</span><b className={`task_chip ${getPriorityClass(selectedTask.priority)}`}>{selectedTask.priority || 'Not available'}</b></div>
                      <div><span>Status</span><b className={`task_chip ${getStatusClass(selectedTask.status)}`}>{selectedTask.status || 'Not available'}</b></div>
                      <div><span>Role</span><b className={`task_chip ${getRoleClass(selectedTask.role)}`}>{selectedTask.role || 'Not available'}</b></div>
                      <div><span>Deadline</span><strong>{selectedTask.deadline || 'Not available'}</strong></div>
                      <div><span>Site location</span><a href="/" onClick={(e) => e.preventDefault()}>View more</a></div>
                      <div><span>Created date</span><strong>{selectedTask.createdAt || 'Not available'}</strong></div>
                      <div><span>Given by</span><strong>{selectedTask.assignedFrom || 'Not available'}</strong></div>
                    </div>
                  </section>

                  <section className="detail_section_CardView">
                    <div className="detail_section_title">
                      <span>02</span>
                      <div>
                        <h3>Personal information</h3>
                        <p>Details associated with the assigned employee.</p>
                      </div>
                    </div>

                    {assigneeDetails ? (
                      <div className="personal_grid_CardView">
                        <div><span>Name</span><strong>{assigneeDetails.username || 'Not available'}</strong></div>
                        <div><span>Work</span><strong>{assigneeDetails.work_type || 'Not available'}</strong></div>
                        <div><span>Phone</span><strong>{assigneeDetails.mobile || 'Not available'}</strong></div>
                        <div><span>Email</span><strong>{assigneeDetails.email || 'Not available'}</strong></div>
                        <div className="full_width_CardView"><span>Current address</span><strong>{assigneeDetails.address || 'Not available'}</strong></div>
                      </div>
                    ) : (
                      <div className="detail_loading_CardView">
                        <span className="loading_dot_CardView" />
                        Loading assignee details...
                      </div>
                    )}
                  </section>

                  <section className="time_summary_CardView">
                    <div>
                      <span>Start time</span>
                      <strong>00:00:00</strong>
                    </div>
                    <div>
                      <span>End time</span>
                      <strong>00:00:00</strong>
                    </div>
                    <div className="total">
                      <span>Total time</span>
                      <strong>00:00:00</strong>
                    </div>
                  </section>
                </div>
              </aside>
            </>
          )}
        </div>
      </main>
    </div>
  );
};

export default CardView;
